export const hexController = (wrapper: HTMLElement): void => {
  const innerElement = wrapper.querySelector('.js-hex-2022-inner') as unknown as HTMLElement

  const linkList = Array.from(wrapper.querySelectorAll('.js-hex-2022-navLink.topBannerHexagon_2022__hexagonSvgWrapper'))

  window.onresize = doALoadOfStuff

  function doALoadOfStuff () {
    const windowWidth = window.innerWidth

    if (windowWidth < 1200) {
      const innerHeight = innerElement.clientHeight

      innerElement.style.marginBottom = `${innerHeight + 20}px`
    } else {
      innerElement.removeAttribute('style')
    }
  }

  doALoadOfStuff()

  const specialTrigger = () => {
    let timer = 500

    linkList.forEach(single => {
      setTimeout(() => {
        single.classList.add('-specialTrigger')
      }, timer)

      timer = timer + 500
    })
  }

  setTimeout(() => {
    specialTrigger()
  }, 800)
}
